import { v4 as uuid } from "uuid";

interface BuildAdTagOptions {
  networkId: string;
  adUnit: string;
  duration?: number;
  size: string;
  clipGame: string;
}

/**
 * Builds a Google Ad Manager (GAM) ad tag URL for video ads
 *
 * @param options - Configuration options
 * @param options.adUnit - The ad unit path (e.g., "player_video_midroll")
 * @param options.networkId - The GAM network code (defaults to 23325224050)
 * @param options.duration - Duration of the video ad is being requested for
 * @param options.size - List of comma separated ad sizes this unit should accept
 * @param options.clipGame - The game of the clip
 * @returns The complete ad tag URL
 */
export function buildAdTag(opts: BuildAdTagOptions): string {
  const params = new URLSearchParams({
    ad_type: "video",
    iu: `/${opts.networkId}/${opts.adUnit}`,
    tfcd: "0",
    npa: "0",
    sz: opts.size,
    gdfp_req: "1",
    unviewed_position_start: "1",
    output: "vast",
    env: "vp",
    impl: "s",
    correlator: uuid(),
    vad_type: "linear",
    documentation_url: window.location.href,
    description_url: window.location.href,
  });

  if (opts?.duration) {
    params.set("vid_d", opts.duration.toString());
  }

  const urlParams = new URLSearchParams(window.location.search);
  const testAds = urlParams.get("testAds");
  const custParams: string[] = [];

  if (testAds) {
    custParams.push(`test%3D${encodeURIComponent(testAds)}`);
  }
  if (opts?.clipGame) {
    custParams.push(`game%3D${encodeURIComponent(opts.clipGame)}`);
  }

  if (custParams.length > 0) {
    params.set("cust_params", custParams.join("%26"));
  }

  return `https://pubads.g.doubleclick.net/gampad/ads?${params.toString()}`;
}
